import { useEffect } from "react";

import useTypedContext from "hooks/useTypedContext";
import { createPlainDataLayer, setSegmentGroup, initPylonChat } from "shared/Analytics";
import { SubscriptionContext } from "views/Account/SubscriptionWrapper";
import { AccountContext } from "views/AccountWrapper";
import usePylonAuthentication from "hooks/usePylonAuthentication";
import { isProductionFedRampEnvironment } from "utils/env";

type ThirdPartyLibsWrapperProps = {
  children: React.ReactNode;
};

const ThirdPartyLibsWrapper = ({ children }: ThirdPartyLibsWrapperProps) => {
  const { accountId, viewer } = useTypedContext(AccountContext);
  const { tier, isTrial } = useTypedContext(SubscriptionContext);
  const { verifyPylonUser } = usePylonAuthentication();
  const isProductionFedRamp = isProductionFedRampEnvironment();

  useEffect(() => {
    if (!viewer?.email || !window.Pylon) {
      return;
    }

    if (!isProductionFedRamp) {
      verifyPylonUser(viewer.email).then((response) => {
        initPylonChat({
          email: viewer.email,
          name: viewer.name,
          avatar: viewer.avatarURL,
          emailHash: response.hash,
        });
      });
    } else {
      initPylonChat({
        email: viewer.email,
        name: viewer.name,
        avatar: viewer.avatarURL,
      });
    }
  }, [viewer, verifyPylonUser, isProductionFedRamp]);

  useEffect(() => {
    // TODO: check if we still need this
    createPlainDataLayer({ account_status: isTrial ? "trial" : "paid" });
  }, [isTrial]);

  useEffect(() => {
    setSegmentGroup();
  }, [tier, isTrial, accountId, viewer?.id]);

  return <>{children}</>;
};

export default ThirdPartyLibsWrapper;
